import React, { FC } from "react";
import { NotificationPayload } from "firebase/messaging";
import { TPayloadNotification } from "@deltasge/marauders-map";
import { Avatar, Button, Grid, Typography } from "@mui/material";
import { history } from "configs";
import { useSnackbar } from "notistack";
import { getUrlFromNotification } from "utils";

export const NotificationComponent: FC<{
  notification: NotificationPayload;
  payload: TPayloadNotification;
}> = ({ payload, notification }) => {
  const { closeSnackbar } = useSnackbar();

  let image: string | undefined;
  let icon: string | undefined;
  const url = getUrlFromNotification(payload);

  if (payload.image) image = payload.image;
  if (payload.icon) icon = payload.icon;
  if (notification?.image) image = notification?.image;

  return (
    <Grid container alignItems="center">
      {icon && (
        <Grid item sx={{ pr: 1 }}>
          <Avatar src={icon} />
        </Grid>
      )}
      <Grid item flexGrow={1}>
        <Typography variant="subtitle2" component="p">
          {notification?.title}
        </Typography>
        <Typography variant="caption" component="p">
          {notification?.body}
        </Typography>
        {image && <img src={image} />}
      </Grid>
      {url && (
        <Grid item sx={{ pl: 1 }}>
          <Button
            variant="text"
            size="small"
            onClick={() => {
              if (url.startsWith("http")) {
                window.open(url, "_blank", "noopener noreferrer");
              } else {
                history.push(url);
              }
              closeSnackbar();
            }}
          >
            Abrir
          </Button>
        </Grid>
      )}
    </Grid>
  );
};
